import React from "react";

import { cn } from "../../../common/u1/cn";
import { relativeTime } from "../../../common/u1/relativeTime";
import { ticketState, ticketRef, ticketRaisedAt } from "./supportTickets";

/* The tickets this viewer has raised. */
const TONES = {
  success: "bg-[var(--success-soft)] text-[var(--success)]",
  warning: "bg-[var(--warning-soft)] text-[var(--gold-deep)]",
  info: "bg-[var(--claimed-bg)] text-[var(--navy)]",
  danger: "bg-[var(--coral-soft)] text-[var(--coral-deep)]",
};

export const TicketRow = ({ ticket }) => {
  const state = ticketState(ticket?.status);
  const when = relativeTime(ticketRaisedAt(ticket));
  const ref = ticketRef(ticket);

  return (
    <li
      className={cn(
        "border-t border-[var(--line)] pt-4 first:border-t-0 first:pt-0",
        "pb-4 last:pb-0"
      )}
    >
      <div className="flex items-start justify-between gap-3">
        <span
          className={cn(
            "text-[12px] font-semibold tracking-[.04em]",
            "text-[var(--muted-2)] font-mono"
          )}
        >
          {ref}
        </span>

        <span
          className={cn(
            "inline-flex shrink-0 items-center gap-1.5 rounded-full px-2.5 py-1",
            "text-[12px] font-semibold font-sans",
            TONES[state.tone] || TONES.info
          )}
        >
          <span aria-hidden="true" className="h-[6px] w-[6px] rounded-full bg-current" />
          {state.label}
        </span>
      </div>

      <p className="mt-1.5 mb-0 text-[14.5px] font-bold text-[var(--ink)] font-sans">
        {ticket?.subject}
      </p>
      {when && (
        <p className="mt-1 mb-0 text-[12.5px] text-[var(--muted)] font-sans">
          Raised {when}
        </p>
      )}
    </li>
  );
};

export const RecentActivity = ({ tickets = [], className = "" }) => (
  <section
    aria-labelledby="u1-support-activity"
    className={cn(
      "rounded-[16px] border border-[var(--line)] bg-white p-5",
      className
    )}
  >
    <h2
      id="u1-support-activity"
      className="m-0 text-[17px] font-bold text-[var(--ink)] font-sans"
    >
      Recent activity
    </h2>
    <p className="mt-1 mb-4 text-[12.5px] text-[var(--muted)] font-sans">
      {tickets.length > 0
        ? /* The design's wording. Nothing windows the payload to 30 days — it
             carries every ticket on the account — so this is the design's
             claim, not something the data enforces. See F-035. */
          "Tickets you raised in the last 30 days."
        : "Tickets you raise will appear here."}
    </p>

    {tickets.length > 0 && (
      <ul className="m-0 flex list-none flex-col p-0">
        {tickets.map((ticket, i) => (
          <TicketRow key={ticket?.supportID ?? `ticket-${i}`} ticket={ticket} />
        ))}
      </ul>
    )}
  </section>
);

export default RecentActivity;
